import { makeObservable } from 'mobx';
import { StoreNode } from '../../store';
import { Store } from '../../store/store';
import { JobModel, Team } from '../../entities';
import { GenerativeAiProvider } from '@clipr/lib';

export class AiService
  extends StoreNode {

  constructor(store: Store) {
    super(store);
    makeObservable(this);
  }

  getCliprGptEnabled(team?: Team | null) {
    const { user } = this.store;
    const { localUser } = this.store.profilePage;
    return !!(team?.cliprGptEnabled ?? localUser?.cliprGptEnabled ?? user?.cliprGptEnabled);
  }

  getUserProvider() {
    const generativeAiSettings = (this.store.profilePage.localUser ?? this.store.user)?.generativeAiSettings;
    if (!generativeAiSettings?.cliprGptEnabled)
      return null;

    return generativeAiSettings?.provider;
  }

  getTeamProvider(teamId: string) {
    const generativeAiSettings = this.store.teamManager.getTeam(teamId)?.generativeAiSettings;
    if (!generativeAiSettings?.cliprGptEnabled)
      return null;

    return generativeAiSettings?.provider;
  }

  getOwnerProvider(job: JobModel) {
    const generativeAiSettings = (job.owner?.team ?? job.owner?.user)?.generativeAiSettings;
    if (!generativeAiSettings?.cliprGptEnabled)
      return null;

    return job.owner?.team?.generativeAiProvider || job.owner?.user?.generativeAiProvider;
  }

  getAiProvider(job?: JobModel | null, teamId?: string | null): GenerativeAiProvider | null {
    if (!job)
      return null;

    let gptProvider = this.getUserProvider() || this.getOwnerProvider(job);

    if (teamId) {
      gptProvider = this.getTeamProvider(teamId);
    }

    return gptProvider;
  }
}
